import { TFunction } from 'i18next';
import { UserPlatformEnum } from '../enums/platform.enum';

export interface ChatSuggestedQuestionDefinition {
    id: string;
    titleKey: string;
}

export interface ChatSuggestedQuestionsProfile {
    id: string;
    questions: ChatSuggestedQuestionDefinition[];
    includeFavorites: boolean;
    includeDynamicQuestions: boolean;
}

interface ResolveChatSuggestedQuestionsProfileParams {
    userNickname?: string;
    userPlatform?: UserPlatformEnum;
}

const DEFAULT_CHAT_SUGGESTED_QUESTIONS: ChatSuggestedQuestionDefinition[] = [
    { id: '1', titleKey: 'chat.suggestedQuestions.dayOperationSummary' },
    { id: '2', titleKey: 'chat.suggestedQuestions.customerDeliveryDetails' },
    { id: '3', titleKey: 'chat.suggestedQuestions.orderStatus' },
    { id: '4', titleKey: 'chat.suggestedQuestions.routeStatus' },
];

const STORK_CHAT_SUGGESTED_QUESTIONS: ChatSuggestedQuestionDefinition[] = [
    { id: '1', titleKey: 'chat.suggestedQuestions.storkOperationSummary' },
    { id: '2', titleKey: 'chat.suggestedQuestions.storkDelayedTrips' },
    { id: '3', titleKey: 'chat.suggestedQuestions.storkOperationalPunctuality' },
    { id: '4', titleKey: 'chat.suggestedQuestions.storkStayTime' },
];

const CHAT_SUGGESTED_QUESTIONS_PROFILES: Array<
    ChatSuggestedQuestionsProfile & {
        matches: (params: ResolveChatSuggestedQuestionsProfileParams) => boolean;
    }
> = [
    {
        id: 'stork',
        questions: STORK_CHAT_SUGGESTED_QUESTIONS,
        includeFavorites: false,
        includeDynamicQuestions: false,
        matches: ({ userNickname, userPlatform }) =>
            userPlatform === UserPlatformEnum.STORK || userNickname?.trim().toLowerCase() === 'isstork',
    },
    {
        id: 'default',
        questions: DEFAULT_CHAT_SUGGESTED_QUESTIONS,
        includeFavorites: true,
        includeDynamicQuestions: true,
        matches: () => true,
    },
];

export const resolveChatSuggestedQuestionsProfile = (
    params: ResolveChatSuggestedQuestionsProfileParams,
): ChatSuggestedQuestionsProfile => {
    return (
        CHAT_SUGGESTED_QUESTIONS_PROFILES.find((profile) => profile.matches(params)) ??
        CHAT_SUGGESTED_QUESTIONS_PROFILES[CHAT_SUGGESTED_QUESTIONS_PROFILES.length - 1]
    );
};

export const buildChatSuggestedQuestions = (t: TFunction, questions: ChatSuggestedQuestionDefinition[]) =>
    questions.map((question) => ({
        id: question.id,
        title: t(question.titleKey),
    }));
